import {flare} from "@flareapp/flare-client";
import {flareVue} from "@flareapp/flare-vue";
import i18n from "./lang.js";

flare.light(process.env.MIX_FLARE_KEY);


import {createApp} from 'vue';
import ModeSwitch from "./components/ModeSwitch";
import LangMenu from "./components/LangMenu";
import Notification from './components/Notification'
import MobilePanel from './components/MobilePanel'

require('./bootstrap');

const appSimple = createApp({})
appSimple.use(flareVue)
appSimple.directive('focus', {
    mounted(el) {
        el.focus()
    }
})

appSimple.mixin({
    methods: {
        asset: function (path) {
            return `${process.env.MIX_ASSET_URL}/${path}`
        },
    },
})
appSimple.component('mobile-panel', MobilePanel)
appSimple.component('mode-switch', ModeSwitch)
appSimple.component('my-notification', Notification)
appSimple.component('lang-menu', LangMenu)


appSimple.use(i18n).mount("#app")
